import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; // Fix import syntax
import { isTokenValid } from './utils/tokenUtils';

// Create context
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const updateUserData = user => {
    setUserData(user);
  };

  // On first load, check if token exists and is valid
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (isTokenValid()) {
      try {
        const decodedToken = jwtDecode(token);
        setUserData({
          ...decodedToken,
          email: decodedToken.email || decodedToken.sub,
          role: decodedToken.role || 'user',
        });
      } catch (error) {
        console.error('Error decoding token:', error);
        localStorage.removeItem('token');
      }
    } else {
      // Invalid token, clear user data
      setUserData(null);
    }
    setIsLoading(false);
  }, []);

  // Set up interval to periodically check token validity
  useEffect(() => {
    const tokenCheckInterval = setInterval(() => {
      if (!isTokenValid() && userData) {
        // Token expired while user was logged in
        updateUserData(null);
      }
    }, 60000); // Check every minute

    return () => clearInterval(tokenCheckInterval);
  }, [userData]);

  return (
    <UserContext.Provider value={{ userData, updateUserData, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
